import {SettingsNavigationProperty} from "@pata/settings";
import {getTranslations} from "next-intl/server";

export default async function fetchSubMenu(): Promise<SettingsNavigationProperty[]> {
    const t = await getTranslations('Navigation')
    
    return [
        { name: t('about-us'), path: "/about-us", htmlId: 33 },
        { name: t('contact-us'), path: "/contact-us", htmlId: 32 },
    ]
}